import { render } from "./Main.vue?vue&type=template&id=3c486720&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=3c486720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c486720"

export default script